import * as angular from 'angular';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)
  .factory('CourseDiff', function(NvBaseModel, ImSchool: ImSchool, UtilitiesService, PublicConfig, $http) {
    const PERMISSIONING_MODEL_NAME = 'COURSE_DIFF';
    const relationToUserPath = 'createdBy.userId';

    const CourseDiff = NvBaseModel(
      // eslint-disable-line new-cap
      '/v1/courseDiffs/:id',
      { id: '@_id' },
      null,
      null,
      PERMISSIONING_MODEL_NAME,
      relationToUserPath,
    );

    /**
     * Update a single gap plan
     * @param id {string}
     * @param path {string} dot notation path to change
     * @param newValue {any} new value to set at path
     * @returns {HttpPromise}
     */
    CourseDiff.singleUpdate = (id, path, newValue) => {
      const patch = UtilitiesService.setFieldByPath({}, path, newValue);
      return $http.patch(PublicConfig.NV_API_ORIGIN + '/v1/courseDiffs/' + id, patch);
    };

    return CourseDiff;
  });
